export default (map) => (dispatch, getState) => {
  dispatch({type: 'set_map', map})
}




/** WEBPACK FOOTER **
 ** ./app/actions/setMap.js
 **/